function getConfigurationFromSettings(settings) {
  return settings.features || {};
}

export default getConfigurationFromSettings;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/services/splitChanges/offline/browser.js
// module id = null
// module chunks = 